// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Popover__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Popover/Popover.scss
 ** module id = 929
 ** module chunks = 1
 **/